import { assign } from "xstate";
import { PaymentContext, TransactionStatus } from "../../../types";

export const setContextForRetry = assign<PaymentContext>((context: PaymentContext) => {
    return {
        ...context,
        inquiryRetryCount: 0,
        cancelRetryCount: 0,
        message: '',
        status: TransactionStatus.inquiryOnRetry,
    }
});
